import { ReactNode } from 'react';

import { Box, BoxProps } from '@mui/system';

type CompetitionRankingColumnDefaultProps = BoxProps & {
  value?: ReactNode;
};

export const CompetitionRankingColumnDefault = ({
  value,
  sx,
  ...rest
}: CompetitionRankingColumnDefaultProps) => (
  <Box sx={{ width: '2rem', flex: '0 0 2rem', ...sx }} {...rest}>
    {value}
  </Box>
);
